import { IntegrationNotice } from '../IntegrationNotice'
import Styles from '../IntegrationInitializationModal.module.scss'

export const WixNotice = () => (
  <IntegrationNotice
    connectionGuideLink="https://help.blaze.ai/en/articles/13417059-connect-blaze-to-wix"
    message={
      <div className={Styles.message}>
        To connect your Wix site for blog publishing, ensure:
        <ul className={Styles.list}>
          <li>You are the site owner or have admin access to the Wix site.</li>
          <li>Your Wix site has a blog section set up.</li>
        </ul>
        <div className={Styles.note}>
          <strong>Note:</strong> You'll be redirected to Wix's secure login page to authorize
          Blaze's access to your site's blog.
        </div>
      </div>
    }
  />
)

